import React, {Component} from 'react';
import {connect} from 'react-redux';

// Components
import {Grid} from '@material-ui/core';
import ProductImage from 'Components/commonOrder/ProductImage';
import {T} from 'Actions/translate';
import Anchor from 'Components/common/Anchor';

import {getSkuReplenishmentDetails} from 'Actions/host';
import PropTypes from 'prop-types';
import CommonDialogWrapper from './CommonShippingDetails';

// import util from 'Utils/commonUtil';

class ReplenishmentProductDetails extends Component {
    state = {
        exitOpened: false,
    };

    openDialog = (name, orderId, productId) => {
        this.setState({
            [name]: true,
        });
        this.props.getSkuReplenishmentDetails({
            orderId: orderId,
            productId: productId,
        });
    };

    closeDialog = (name) => {
        if (this.state[name]) {
            this.setState({
                [name]: false,
            });
        }
    };

    showShippmentDetails = (orderId, productId) => {
        this.openDialog('exitOpened', orderId, productId);
    };

    render() {
        const {f1OrderProduct, skuReplenishmentDetail} = this.props;
        const {exitOpened} = this.state;
        const tableThContent = [
            'host_fone_receive_amount',
            'host_fone_receive_date',
        ];

        return (
            <Grid
                className="replenishment-product-details"
                container
                spacing={0}>
                <Grid className="left-content-grid" item xs={4}>
                    <div className="image-box">
                        <ProductImage
                            src={
                                f1OrderProduct.product &&
                                f1OrderProduct.product.productPic
                            }
                            key={
                                f1OrderProduct.product &&
                                f1OrderProduct.product.productPic
                            }
                            alt={
                                f1OrderProduct.product &&
                                f1OrderProduct.product.productName
                            }
                        />
                    </div>
                </Grid>

                <Grid className="right-content-grid" item xs={8}>
                    <Grid
                        className="product-details"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="sc-sku" item xs={12}>
                            <span>{f1OrderProduct.product.sku}</span>
                        </Grid>

                        <Grid className="replenishment-amount" item xs={6}>
                            <span>
                                {T('fone_order_replenishment_amount')}
                                {f1OrderProduct.quantity}
                            </span>
                        </Grid>

                        <Grid className="recieve-amount" item xs={6}>
                            <span>
                                {T('fone_order_receive_amount')}
                                {f1OrderProduct.receivedQuantity}
                            </span>
                        </Grid>

                        <Grid className="recieve-date" item xs={12}>
                            <span>
                                {T('fone_order_specifications_colon')}
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: f1OrderProduct.product
                                            .specifications,
                                    }}
                                />
                            </span>
                        </Grid>
                    </Grid>
                    <div className="shippment-details">
                        <Anchor
                            className={
                                f1OrderProduct.receivedQuantity === 0
                                    ? 'btn btn-disabled'
                                    : 'btn'
                            }
                            disabled={
                                f1OrderProduct.receivedQuantity === 0
                                    ? true
                                    : false
                            }
                            onClickOfSingleTap={() =>
                                this.showShippmentDetails(
                                    f1OrderProduct.orderId,
                                    f1OrderProduct.productId,
                                )
                            }>
                            {T('fone_order_shippment_details')}
                        </Anchor>
                    </div>
                </Grid>
                <CommonDialogWrapper
                    tableThContent={tableThContent}
                    skuReplenishmentDetailData={skuReplenishmentDetail}
                    closeDialog={this.closeDialog}
                    exitOpened={exitOpened}
                />
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;
    return {
        skuReplenishmentDetail: host.skuReplenishmentDetail,
    };
};

const mapDispatchToProps = {
    getSkuReplenishmentDetails,
};

ReplenishmentProductDetails.propTypes = {
    getSkuReplenishmentDetails: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReplenishmentProductDetails);
